var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,14h-9.4738159C34.2511597,12.348877,36,9.8261719,36,7c0-2.7568359-2.2431641-5-5-5 c-3.050293,0-5.647583,2.4403076-7,6.1152344C22.647583,4.4403076,20.050293,2,17,2c-2.7568359,0-5,2.2431641-5,5 c0,2.8261719,1.7489014,5.348877,4.4738159,7H7c-1.6542969,0-3,1.3457031-3,3v2c0,1.302002,0.838501,2.4016113,2,2.8156738V43 c0,1.6542969,1.3457031,3,3,3h30c1.6542969,0,3-1.3457031,3-3V21.8156738C43.161499,21.4016113,44,20.302002,44,19v-2 C44,15.3457031,42.6542969,14,41,14z M22,16.5h4V44h-4V16.5z M31,4c1.6542969,0,3,1.3457031,3,3 c0,3.6228027-3.9534912,6.6115723-8.9989014,6.9645996C25.0131836,8.5593262,27.755249,4,31,4z M14,7c0-1.6542969,1.3457031-3,3-3 c3.244751,0,5.9868164,4.5593262,5.9989014,9.9645996C17.9534912,13.6115723,14,10.6228027,14,7z M6,17c0-0.5517578,0.4482422-1,1-1 h13v4H7c-0.5517578,0-1-0.4482422-1-1V17z M8,43V22h12v22H9C8.4482422,44,8,43.5517578,8,43z M40,43c0,0.5517578-0.4482422,1-1,1H28 V22h12V43z M42,19c0,0.5517578-0.4482422,1-1,1H28v-4h13c0.5517578,0,1,0.4482422,1,1V19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftMedium);
export default __webpack_public_path__ + "static/media/gift--medium.68a0b48c9d0b6ccd5b34cb4fba784cdd.svg";
export { ForwardRef as ReactComponent };